'use client';

import React from 'react';
import { Color, ChromePicker, ColorChangeHandler, ColorResult } from 'react-color';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';

type ColorPickerType = {
  color?: Color | undefined;
  inputColor?: string;
  percentage?: string;
  className?: string | undefined;
  styles?: any;
  onChangeColor?: ColorChangeHandler;
  onChangeColorComplete?: (
    color: ColorResult & { source: 'rgb' | 'hex' | 'hsl' },
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  onChangeInputColor?: React.ChangeEventHandler<HTMLInputElement>;
  onBlurInputColor?: React.FocusEventHandler<HTMLInputElement>;
  onChangePercentage?: (val: string) => void;
  isShowInputColor?: boolean;
  isShowPercentage?: boolean;
};

export default function ColorPicker({
  color,
  inputColor,
  percentage,
  className,
  styles,
  onChangeColor,
  onChangeColorComplete,
  onChangeInputColor,
  onBlurInputColor,
  onChangePercentage,
  isShowInputColor = true,
  isShowPercentage = true,
}: ColorPickerType) {
  return (
    <div className='flex items-center space-x-3'>
      <Popover>
        <PopoverTrigger>
          <div
            className='h-12 w-12 rounded border border-[#E4E2E2]'
            style={{ backgroundColor: `${color}` }}
          >
            {!color && (
              <svg
                width='46'
                height='47'
                viewBox='0 0 46 47'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <line x1='45.3574' y1='0.349647' x2='0.357418' y2='46.3497' stroke='#DF4D4D' />
              </svg>
            )}
          </div>
        </PopoverTrigger>
        <PopoverContent>
          <ChromePicker
            color={color}
            className={className}
            styles={styles}
            onChange={onChangeColor}
            onChangeComplete={onChangeColorComplete as ColorChangeHandler}
            disableAlpha={true}
          />
        </PopoverContent>
      </Popover>
      {isShowInputColor && (
        <Input
          type='text'
          className='w-full'
          value={inputColor}
          onChange={onChangeInputColor}
          onBlur={onBlurInputColor}
          placeholder='Cth. #000000'
        />
      )}
      {isShowPercentage && (
        <Input
          type='text'
          className='w-20'
          value={percentage}
          maxLength={3}
          max={100}
          onChange={(e) => {
            const formatted = e.target.value?.replace(/[^0-9]/g, '');
            if (Number(formatted) > 100) {
              onChangePercentage?.('100');
            } else {
              onChangePercentage?.(formatted);
            }
          }}
          placeholder='100'
          rightContent='%'
        />
      )}
    </div>
  );
}
